import React from 'react';
import ReactDOM from 'react-dom';
import Footer from './App';
import './styles/index.css';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <div>
      <Analytics />
      <Footer />
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
